/**
 * Winners Wall Slider Functionality
 *
 * @since 1.1.0
 * @package lockbusters
 */
(function($) {
    $(document).ready(function(){

		if ( ! ( 'flickity' in $.fn ) ) {
			return;
		} else {
			$('.winners-carousel').flickity({
				cellSelector: '.winners-slider-wrap',
				pageDots: false,
				cellAlign: 'right',
				imagesLoaded: true,
				fullscreen: true,
				contain: true
            });
        }

        if ( ! ( 'swiper' in $.fn ) ) {
            return;
        } else {
            var singleRoomSlider = new Swiper ('#room-gallery', {
                loop: true,
                autoplay: 2500,
                speed: 650
            });
        }

    });
})(jQuery);
